// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  min-height: calc(100vh - 160px);
}

.settings-header {
  margin-bottom: 24px;
}

.settings-title {
  margin: 0 !important;
}

.settings-subtitle {
  color: #8c8c8c;
  font-size: 14px;
}

.settings-module-card {
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 0.24s ease, box-shadow 0.24s ease;
  height: 100%;
}

.settings-module-card .ant-card-body {
  padding: 22px;
  height: 100%;
}

.settings-module-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);
}

.settings-module-card:hover .settings-card-icon {
  transform: scale(1.08);
}

.settings-module-content {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  min-height: 132px;
}

.settings-card-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  transition: transform 0.24s ease;
  flex-shrink: 0;
}

.settings-card-icon--accounts {
  background: #e6f4ff;
  color: #1677ff;
}

.settings-card-icon--security {
  background: #fff7e6;
  color: #fa8c16;
}

.settings-card-icon--configuration {
  background: #f6ffed;
  color: #52c41a;
}

.settings-card-main {
  flex: 1;
  min-width: 0;
}

.settings-card-text-stack {
  width: 100%;
}

.settings-card-title {
  font-size: 16px;
  line-height: 1.2;
  font-weight: 600;
  color: #262626;
}

.settings-card-description {
  font-size: 13px;
  line-height: 1.45;
  color: #595959;
}

.settings-card-arrow {
  font-size: 16px;
  color: #8c8c8c;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .settings-module-content {
    min-height: 118px;
  }
}

@media (max-width: 576px) {
  .settings-module-card .ant-card-body {
    padding: 18px;
  }

  .settings-card-title {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/pages/Settings/settings.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;EACf,uDAAuD;EACvD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".settings-page {\n  min-height: calc(100vh - 160px);\n}\n\n.settings-header {\n  margin-bottom: 24px;\n}\n\n.settings-title {\n  margin: 0 !important;\n}\n\n.settings-subtitle {\n  color: #8c8c8c;\n  font-size: 14px;\n}\n\n.settings-module-card {\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  cursor: pointer;\n  transition: transform 0.24s ease, box-shadow 0.24s ease;\n  height: 100%;\n}\n\n.settings-module-card .ant-card-body {\n  padding: 22px;\n  height: 100%;\n}\n\n.settings-module-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);\n}\n\n.settings-module-card:hover .settings-card-icon {\n  transform: scale(1.08);\n}\n\n.settings-module-content {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  min-height: 132px;\n}\n\n.settings-card-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  transition: transform 0.24s ease;\n  flex-shrink: 0;\n}\n\n.settings-card-icon--accounts {\n  background: #e6f4ff;\n  color: #1677ff;\n}\n\n.settings-card-icon--security {\n  background: #fff7e6;\n  color: #fa8c16;\n}\n\n.settings-card-icon--configuration {\n  background: #f6ffed;\n  color: #52c41a;\n}\n\n.settings-card-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.settings-card-text-stack {\n  width: 100%;\n}\n\n.settings-card-title {\n  font-size: 16px;\n  line-height: 1.2;\n  font-weight: 600;\n  color: #262626;\n}\n\n.settings-card-description {\n  font-size: 13px;\n  line-height: 1.45;\n  color: #595959;\n}\n\n.settings-card-arrow {\n  font-size: 16px;\n  color: #8c8c8c;\n  flex-shrink: 0;\n}\n\n@media (max-width: 992px) {\n  .settings-module-content {\n    min-height: 118px;\n  }\n}\n\n@media (max-width: 576px) {\n  .settings-module-card .ant-card-body {\n    padding: 18px;\n  }\n\n  .settings-card-title {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
